export const getImageBase64FromFile = (data, callback) => {
  if (data) {
    const fileReader = new FileReader();
    fileReader.onloadend = () => callback(fileReader.result, data.name);
    fileReader.readAsDataURL(data);
  }
};
